module.exports = __webpack_public_path__ + "img/icon-zt.35f38a55.png";